export default __webpack_public_path__ + "static/media/003-postcard.d57dfaab.svg";